import tw, { styled } from 'twin.macro';

const MarkdownPreformattedText = styled.pre`
  ${tw`block w-full p-4 rounded bg-gray-50 overflow-x-auto text-sm font-mono`}
  border: 1px solid ${({ theme }) => theme.warning};
  white-space: pre;

  .message-type-markdown & {
    ${tw`p-2 m-0`}
  }
`;

export default MarkdownPreformattedText;
